import axios from 'axios'
import { useAuthStore } from '@/stores/auth'

const http = axios.create({
  baseURL: import.meta.env.DEV
    ? '/' // In development, requests go through Vite proxy (see vite.config.ts > server.proxy)
    : 'https://api.sureface.com', // In production, requests go directly to the API
})

http.interceptors.request.use((config) => {
  const authStore = useAuthStore()
  const token = authStore.token

  if (token) {
    config.headers.Authorization = `Token ${token}`
  }

  return config
})

export default http
